import React, { useState, useLayoutEffect, useMemo } from "react";
import { SemanticVariantTypes } from "@hitachivantara/uikit-react-core";
import { useLocation } from "react-router-dom";

import { SnackbarProvider } from "lib/provider/SnackbarProvider";
import Banner from "components/common/Banner";

export const NotificationContext = React.createContext<NotificatioContextValue>(
  {
    removedCount: 0,
    setRemovedCount: () => undefined,
    showBanner: false,
    setShowBanner: () => undefined,
    bannerMessage: "",
    setBannerMessage: () => undefined,
    bannerVariant: "warning",
    setBannerVariant: () => undefined,
  }
);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { pathname } = useLocation();

  const [removedCount, setRemovedCount] = useState(0);
  const [showBanner, setShowBanner] = useState(false);
  const [bannerMessage, setBannerMessage] = useState("");
  const [bannerVariant, setBannerVariant] =
    useState<SemanticVariantTypes>("warning");

  const duration = removedCount > 1 ? 0 : 500;

  const reset = () => {
    setRemovedCount(0);
    setShowBanner(false);
    setBannerMessage("");
    setBannerVariant("warning");
  };

  useLayoutEffect(reset, [pathname]);

  const banner = useMemo(
    () => (
      <Banner
        open={showBanner}
        variant={bannerVariant}
        showIcon
        onClose={reset}
        label={bannerMessage}
        transitionDuration={duration}
      />
    ),
    [bannerMessage, bannerVariant, showBanner, duration]
  );

  return (
    <NotificationContext.Provider
      value={{
        removedCount,
        setRemovedCount,
        showBanner,
        setShowBanner,
        bannerMessage,
        setBannerMessage,
        bannerVariant,
        setBannerVariant,
      }}
    >
      {banner}
      <SnackbarProvider>{children}</SnackbarProvider>
    </NotificationContext.Provider>
  );
};
